<template>
    <component :is="component" v-if="localized" v-bind="$props" />
    <div v-else class="payment-plan-content">
        <div>
            <div class="type nowrap">{{ $t("plan.type", { providerKey: paymentPlan.providerKey }) }}</div>
            <div class="term">
                <span v-if="paymentPlan.durationMonths">{{ paymentPlan.durationMonths }} Months </span>
                <span v-if="paymentPlan.durationMonths && paymentPlan.apr !== null"> @ </span>
                <span v-if="paymentPlan.apr !== null">{{ paymentPlan.apr.toFixed(2) }}% APR</span>
            </div>

            <div :class="{ 'text-error': !fullyCovered }">
                <span>
                    <b :class="{ 'label text-error': !fullyCovered, label: fullyCovered }"> Financed Amount: </b>
                    {{ financedAmountCents | currencyWhole }}
                </span>
            </div>

            <div v-if="!fullyCovered">
                <span class="text-error"> *Requested financed amount not fully covered </span>
            </div>
            <div v-show="paymentPlan.expireDateTime" class="expire">
                <span class="font-weight-bold">Offer Exp: </span>
                {{ paymentPlan.expireDateTime | date }}
                ({{ paymentPlan.expireDateTime | days }} days)
            </div>
        </div>
    </div>
</template>

<script>
    import LocalizedComponentMixin from "@/components/localization/LocalizedComponentMixin"

    export default {
        name: "PaymentPlanContent",
        mixins: [LocalizedComponentMixin],
        props: {
            paymentPlan: {
                type: Object,
                required: true,
            },
            providerKey: {
                type: String,
                required: true,
            },
            fullyCovered: {
                type: Boolean,
                required: true,
            },
            financedAmountCents: {
                type: Number,
            },
        },
        data() {
            return {
                componentType: "paymentPlanContent",
            }
        },
    }
</script>

<style lang="scss">
    .text-error {
        color: $error-color-shade;
    }
</style>
